import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import styles from './Resetpass.module.css'; // <-- import module.css
import config from '../../config/config';

const ResetPass = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setSuccessMsg('');
    setErrorMsg('');

    if (password !== confirmPassword) {
      setErrorMsg('Passwords do not match');
      return;
    }

    try {
      const res = await axios.post(`${config.apiBaseUrl}/api/admin/reset-password/${token}`, {
        password,
        confirmPassword
      });
      setSuccessMsg(res.data.message);

      setTimeout(() => {
        window.location.href = '/admin/0083/login'; 
      }, 2000);

    } catch (error) {
      if (error.response && error.response.data.message) {
        setErrorMsg(error.response.data.message);
      } else {
        setErrorMsg('Something went wrong, try again.');
      }
    }
  };

  return (
    <div className={styles.resetPassContainer}>
      <h2>Reset Password</h2>
      <form onSubmit={handleResetPassword} className={styles.form}>
        {successMsg && <div className={styles.success}>{successMsg}</div>}
        {errorMsg && <div className={styles.error}>{errorMsg}</div>}

        <input
          type="password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className={styles.input}
        />

        <input
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          className={styles.input}
        />

        <button type="submit" className={styles.button}>Reset Password</button>
      </form>
    </div>
  );
};

export default ResetPass;
